import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, NavController } from '@ionic/angular';
import * as moment from 'moment';
import { filter, map, take } from 'rxjs/operators';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { TeeTimeBooking } from 'src/data/mygolf.data';
import { PlayerHomeInfo, PlayerInfo } from 'src/data/player-data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { PlayerHomeDataService } from 'src/redux/player-home';

  /** 
   * @param confirmationType - This is to determine which confirmation to display - default is 'common'
   * @param message - This is the body message for the Confirmation dialog
   * @param txtHeaderTitle - This is the Header Title shown in the dialog
    * @param txtCancelBtn - Text for the Cancel button - default is Cancel
    * @param txtConfirmBtn  - Text for the Confirm button - default is OK
    * @param txtAdd1Button  - Text for the 3rd button - only visible when there is text passed
   **/
@Component({
  selector: 'modal-common-confirmation',
  templateUrl: './common-confirmation.component.html',
  styleUrls: ['./common-confirmation.component.scss'],
})
export class CommonConfirmationModal implements OnInit {

  @Input() clubName: string;
  @Input() courseName: string;
  @Input() teeOffDate: any;
  @Input() teeOffTime: any;
  @Input() teeTimeSlotDisplay: any;
  @Input() playerReq: any;
  @Input() holesPlayed: any;
  @Input() buggyRequired: any;
  @Input() caddyRequired: any;
  @Input() fromClub: any;
  @Input() clubBookingPlayers: any;
  @Input() userType: any;
  @Input() playerHomeInfo$: any;
  @Input() player$: any;
  @Input() bookForOther: any;
  @Input() captchaResponse: any;
  @Input() afterBook: any;
  @Input() currSession: any;
  @Input() clubInfo: any;
  @Input() appAttribute: any;

  @Input() message: string;

  @Input() txtHeaderTitle: string = 'Confirmation';
  @Input() txtCancelBtn: string = 'Cancel';
  @Input() txtConfirmBtn: string = 'OK';
  @Input() txtAdd1Button: string;

  @Input() confirmationType: string = 'common';

  @Input() compName: string;
  @Input() compDetails: any;
  bookingSuccess: boolean = false;
  constructor(
    private router: Router,
    private nav: NavController,
    private mg2uUtil: mygolfUtils,
    private alertCtrl: AlertController,
    private modalCtl: ModalController,
    private loadingCtrl: LoadingController,
    private flightService: ClubFlightService,
    private playerHomeService: PlayerHomeDataService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    console.log(this.message,'-Message-')
    this.cdr.detectChanges();
  }

  async resolved(captchaResponse: string) {
    this.captchaResponse = await captchaResponse;
    this._goBookNow()
  }

  _goBookNow() {

    let _courseId = this.teeTimeSlotDisplay.slot.startCourse.id;
    let _totalPlayers = this.playerReq; //this.teeTimeSlotDisplay.slot.maxPlayers;
    let _teeOffDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate).format(
      'YYYY-MM-DD'
    );
    let _fromTime = moment(
      this.teeTimeSlotDisplay.slot.teeOffTime,
      'HH:mm:ss'
    ).format('HH:mm');
    let _toTime = moment(
      this.teeTimeSlotDisplay.slot.teeOffTime,
      'HH:mm:ss'
    ).format('HH:mm');
    let _currDateTime = moment().toISOString();
    let _ninesPlaying = parseInt(this.holesPlayed);
    let _minPlayers = this.playerReq; //this.teeTimeSlotDisplay.slot.minPlayers;
    let _maxAllowedBuggy =
      Math.floor(
        this.playerReq / this.teeTimeSlotDisplay.slot.maxPlayersPerBuggy
      ) +
      (this.playerReq % this.teeTimeSlotDisplay.slot.maxPlayersPerBuggy);
    let _maxAllowedCaddy =
      Math.floor(
        this.playerReq / this.teeTimeSlotDisplay.slot.maxPlayersPerCaddy
      ) +
      (this.playerReq % this.teeTimeSlotDisplay.slot.maxPlayersPerCaddy);
    let _buggyReq = this.buggyRequired;
    let _caddyReq = this.caddyRequired;
    let _toHour = parseInt(moment(_fromTime).format('HH'));
    let _toMinute = parseInt(moment(_fromTime).format('mm'));
    let _bookingName;
    let _bookingEmail;
    let _bookingPhone;
    if (this.fromClub) {
      _bookingName = this.clubBookingPlayers.playerName;
      _bookingEmail = this.clubBookingPlayers.email;
      _bookingPhone = this.clubBookingPlayers.phone;
    } else if (this.userType !== 'player') {
    } else {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _bookingName = player.playerName;
        _bookingEmail = player.email;
        _bookingPhone = player.phone;
      });
    }

    let reqBookSlot = {
      courseId: _courseId,
      teeOffDate: _teeOffDate,
      teeOffTimeFrom: _fromTime,
      teeOffTimeTo: _toTime,
      totalPlayers: _totalPlayers,
      buggyRequired: _buggyReq ? _maxAllowedBuggy : 0,
      caddiesRequired: _caddyReq ? _maxAllowedCaddy : 0,
      ninesPlaying: _ninesPlaying,
      bookingName: _bookingName,
      bookingEmail: _bookingEmail,
      bookingPhone: _bookingPhone,
      bookingRequestedAt: null,
      addBookingPlayer: this.fromClub ? true : !this.bookForOther,
    };
    if (this.fromClub) {
      this.flightService
        .clubBookingSlot(reqBookSlot, true, this.captchaResponse)
        .subscribe(
          async (data: any) => {
            this.bookingSuccess = true;
            let _body = data._body;
            let _message = `Before making payment you will need to add players and complete all mandatory options.`;
            if (data.status === 200) {
              let _booking: TeeTimeBooking = data;
              this.afterBook = true;
              let params: NavigationExtras = {
                // replaceUrl: true,
                state: {
                  teeSlotNew: false,
                  teeTimeSlotDisplay: this.teeTimeSlotDisplay,
                  bookingSlot: _booking,
                  clubInfo: _booking.clubData,
                  fromClub: true,
                  needRefresh: true,
                  currSession: this.currSession,
                },
              };
              this.router.navigate(['booking-details'], params);
            } else if (data && data.status !== 200) {
              let _error = data;
              let _msg = 'Something has happened, please try again.';
              _msg =
                _error && _error.errors && _error.errors.length > 0
                  ? _error.errors[0]
                  : _error.error;

              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: _msg,
                buttons: ['Close'],
              });
              alert.present();
              this.captchaResponse = null;
            } else {

              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
              this.captchaResponse = null;
            }
          },
          async (error) => {
            let _error = error;
            this.captchaResponse = null;
            let _msg =
              _error && _error.errorCode
                ? _error.errorMessage
                : 'Something has happened, please try again or contact myGolf2u admin.';

            if (!_error.status) {
              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
            } else {
              let alert = await this.alertCtrl.create({
                header: _error && _error.errorCode ? _error.errorCode : 'Ooops',
                message: _msg,
                buttons: ['Close'],
              });
              alert.present();
            }
          }
        );
    } else if (0 && this.userType === 'booking_agent') {
      this.flightService
        .bookTeeTimeSlot(reqBookSlot, false, this.captchaResponse)
        .subscribe(
          async (data: any) => {
            this.bookingSuccess = true;
            let _body = data._body;
            let _message = `Before making payment you will need to add players and complete all mandatory options.`;
            if (data.status === 200) {
              let loader = await this.loadingCtrl.create({
                spinner: 'crescent',
                showBackdrop: false,
                duration: 30000,
                message: 'Getting booking info...',
              });
              loader.present().then(() => {
                setTimeout(() => {
                  this.flightService
                    .getBookingByReference(this.clubInfo.clubId, _body)
                    .subscribe((resp: any) => {

                      let _booking: TeeTimeBooking = resp;
                      this.afterBook = true;
                      let params: NavigationExtras = {
                        replaceUrl: true,
                        state: {
                          teeSlotNew: false,
                          teeTimeSlotDisplay: this.teeTimeSlotDisplay,
                          bookingSlot: _booking,
                          clubInfo: _booking.clubData,
                          fromClub: true,
                          needRefresh: true,
                          currSession: this.currSession,
                          userType: this.userType,
                        },
                      };
                      this.router.navigate(['booking-details'], params);
                    });
                }, 30000);
              });
            } else if (data && data.status !== 200) {
              let _error = data;
              let _msg = 'Something has happened, please try again.';
              _msg =
                _error && _error.errors && _error.errors.length > 0
                  ? _error.errors[0]
                  : _error.error;

              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: _msg,
                buttons: ['Close'],
              });
              alert.present();
              this.captchaResponse = null;
            } else {

              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
              this.captchaResponse = null;
            }
          },
          async (error) => {
            let _error = error;
            this.captchaResponse = null;
            let _msg =
              _error && _error.errorCode
                ? _error.errorMessage
                : 'Something has happened, please try again or contact myGolf2u admin.';

            if (!_error.status) {
              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
            } else {
              let alert = await this.alertCtrl.create({
                header: _error && _error.errorCode ? _error.errorCode : 'Ooops',
                message: _msg,
                buttons: ['Close'],
              });
              alert.present();
            }
          }
        );
    } else {

      this.flightService
        .bookTeeTimeSlot(reqBookSlot, !this.bookForOther, this.captchaResponse)
        .subscribe(
          async (data: any) => {
            this.bookingSuccess = true;
            // let _body = data._body;
            // let _message =
            //   `Thank you for booking with myGolf2u.<br> Please see 'My Bookings' for details.` +
            //   `<br>Your booking reference : <br><b>` +
            //   _body +
            //   `</b>` +
            //   `<br>
            // Before making payment you will need to add players and complete all mandatory options.`;
            // let _title = 'Booking In Process';
            // let _okTxt = 'Go to My Bookings';
            // let _closeTxt = 'Close';
            // if (this.userType === 'booking_agent')
            //   _closeTxt = 'Continue Booking';
            // if (this.appAttribute && this.appAttribute.bookingRequest) {
            //   let _bookingRequest = this.appAttribute.bookingRequest;
            //   _message = _bookingRequest.message;
            //   _title = _bookingRequest.title;
            //   _okTxt = _bookingRequest.Ok;
            // }
            // if (!!data) {
            //   let _buttons = [];
            //   if (this.fromClub) {
            //     _buttons = [
            //       {
            //         text: 'Close',
            //         handler: () => {
            //           this.afterBook = true;
            //           this.nav.pop();
            //         },
            //       },
            //     ];
            //   } else {
            //     _buttons = [
            //       {
            //         text: _closeTxt,
            //         handler: () => {
            //           this.afterBook = true;
            //           this.nav.pop();
            //         },
            //       },
            //       {
            //         text: _okTxt,
            //         handler: () => {
            //           if (this.userType === 'booking_agent') {
            //             let _teeOffDate =
            //               this.teeTimeSlotDisplay.slot.teeOffDate;
            //             let _teeOffTime =
            //               this.teeTimeSlotDisplay.slot.teeOffTime;
            //             let _currentDate = moment().format('YYYY-MM-DD');
            //             let _partnerInfo = this.mg2uUtil.getPartnerInfo();
            //             let params: NavigationExtras = {
            //               replaceUrl: true,
            //               state: {
            //                 partnerId: _partnerInfo ? _partnerInfo.id : null,
            //                 partnerInfo: _partnerInfo ? _partnerInfo : null,
            //                 type: 'booking_agent',
            //                 startDate: _teeOffDate,
            //                 endDate: _teeOffDate,
            //                 slotFrom: _teeOffTime,
            //                 slotTo: _teeOffTime,
            //                 bookingStart: _currentDate,
            //               },
            //             };
            //             this.router.navigate(['partner-booking-list'], params);
            //           } else {
            //             let params: NavigationExtras = {
            //               replaceUrl: true,
            //               state: {
            //                 fromBookNow: true,
            //                 userType: 'player',
            //                 club: this.mg2uUtil.getSelectedClub()
            //                   ? this.mg2uUtil.getSelectedClub()
            //                   : null,
            //               },
            //             };
            //             this.router.navigate(['tabs/booking-home'], params);
            //           }
            //         },
            //       },
            //     ];
            //   }
            //   let alert = await this.alertCtrl.create({
            //     header: _title,
            //     message: _message,
            //     buttons: _buttons,
            //   });
            //   alert.present();
            // } else {
            //   this.captchaResponse = null;
            //   let alert = await this.alertCtrl.create({
            //     header: 'Ooops',
            //     message: 'Something has happened, please try again.',
            //     buttons: ['Close'],
            //   });
            //   alert.present();
            // }
          },
          async (error) => {

            let _error = error;
            this.captchaResponse = null;
            if (!error.status) {
              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
            } else {
              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message:
                  _error && _error.errors[0]
                    ? _error.errors[0]
                    : 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
            }
          }
        );
    }
  }

  redirectToMyBookings(){
    this.modalCtl.dismiss();
    if (this.userType === 'booking_agent') {
      let _teeOffDate =
        this.teeTimeSlotDisplay.slot.teeOffDate;
      let _teeOffTime =
        this.teeTimeSlotDisplay.slot.teeOffTime;
      let _currentDate = moment().format('YYYY-MM-DD');
      let _partnerInfo = this.mg2uUtil.getPartnerInfo();
      let params: NavigationExtras = {
        replaceUrl: true,
        state: {
          partnerId: _partnerInfo ? _partnerInfo.id : null,
          partnerInfo: _partnerInfo ? _partnerInfo : null,
          type: 'booking_agent',
          startDate: _teeOffDate,
          endDate: _teeOffDate,
          slotFrom: _teeOffTime,
          slotTo: _teeOffTime,
          bookingStart: _currentDate,
        },
      };
      this.router.navigate(['partner-booking-list'], params);
    } else {
      let params: NavigationExtras = {
        replaceUrl: true,
        state: {
          fromBookNow: true,
          userType: 'player',
          club: this.mg2uUtil.getSelectedClub()
            ? this.mg2uUtil.getSelectedClub()
            : null,
        },
      };
      this.router.navigate(['booking-home'], params);
    }
  }

  dismiss(){
    this.modalCtl.dismiss();
  }

  continue(){
    this.modalCtl.dismiss().then(()=>{
      // this.router.navigate(['booking-list']);
      this.nav.pop();
    })
  }

  onCancelButton() {
    let data = {
      confirm: false
    }
    this.modalCtl.dismiss(data)
  }

  onConfirmButton() {
    let data = {
      confirm: true
    }
    this.modalCtl.dismiss(data)
  }

  onAdd1Button() {
    let data = {
      confirm: true,
      confirmExtra: true,
    }
    this.modalCtl.dismiss(data)
  }
}
